import { LLMConfig, LLMProvider, ChatMessage } from '../../types/llm'
import { OpenAIProvider } from './providers/openai'
import { AnthropicProvider } from './providers/anthropic'
import { GoogleProvider } from './providers/google'
import { MistralProvider } from './providers/mistral'
import { CohereProvider } from './providers/cohere'
import { CustomProvider } from './providers/custom'

export interface LLMProviderInterface {
  chat(messages: ChatMessage[], config?: Partial<LLMConfig>): Promise<string>
  streamChat(
    messages: ChatMessage[], 
    config?: Partial<LLMConfig>,
    callbacks?: {
      onToken?: (token: string) => void
      onComplete?: (fullText: string) => void
      onError?: (error: Error) => void
    }
  ): Promise<void>
}

export class LLMService {
  private provider: LLMProviderInterface

  constructor(config: LLMConfig) {
    switch (config.provider) {
      case LLMProvider.OpenAI:
        this.provider = new OpenAIProvider(config)
        break
      case LLMProvider.Anthropic:
        this.provider = new AnthropicProvider(config)
        break
      case LLMProvider.Google:
        this.provider = new GoogleProvider(config)
        break
      case LLMProvider.Mistral:
        this.provider = new MistralProvider(config)
        break
      case LLMProvider.Cohere:
        this.provider = new CohereProvider(config)
        break
      case LLMProvider.Custom:
        this.provider = new CustomProvider(config)
        break
      default:
        throw new Error(`Unsupported provider: ${config.provider}`)
    }
  }

  async chat(messages: ChatMessage[], config?: Partial<LLMConfig>): Promise<string> {
    return this.provider.chat(messages, config)
  }

  async streamChat(
    messages: ChatMessage[], 
    callbacks?: {
      onToken?: (token: string) => void
      onComplete?: (fullText: string) => void
      onError?: (error: Error) => void
    },
    config?: Partial<LLMConfig>
  ): Promise<void> {
    return this.provider.streamChat(messages, config, callbacks)
  }
}
